






























import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import { BOOKING_PURPOSES } from "@/constants/booking"

@Component({
  computed: {
    ...mapState("QuestionnaireAnswer", {
      questionnaire: "questionnaire",
    }),
  },
})
export default class CandidateQuestionnaireDeclaration extends Vue {
  questionnaire!: Model
  bookingPurposes = BOOKING_PURPOSES
}
